import { Period } from '@js-joda/core';
import { ReactElement } from 'react';

import {
   DocplannerAuthenticationFault,
   DocplannerHealthcareProviderConfiguration,
   DocplannerSlotSynchronizationDurationUpdateCommand,
} from '@dreryk/egabinet-docplanner-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent, ModalConfirmButton } from '@dreryk/react-components';

import { integrationTranslationKeys } from '../../translations';
import {
   DocplannerUpdateSynchronizationDaysCountFormBean,
   DocplannerUpdateSynchronizationDaysCountFormController,
} from '../integration.types';

type DocplannerUpdateSynchronizationDaysCountCommandOptions = {
   onSuccess: (currentDocplannerConfiguration: DocplannerHealthcareProviderConfiguration) => void;
};

const useUpdateSynchronizationDaysCountCommand = (
   options: DocplannerUpdateSynchronizationDaysCountCommandOptions
): UseCqrsCommandResult<
   DocplannerHealthcareProviderConfiguration,
   DocplannerUpdateSynchronizationDaysCountFormBean,
   DocplannerAuthenticationFault
> => {
   return useCqrsCommand(
      (parameters) => {
         const command = new DocplannerSlotSynchronizationDurationUpdateCommand();
         command.slotSynchronizationDuration = Period.ofDays(parameters.synchronizationDaysCount!);
         return command;
      },
      {
         onSuccess: (result) => {
            options.onSuccess(result);
            dispatchSnackbarPositiveEvent(integrationTranslationKeys.synchronizationDaysCountHasBeenUpdated);
         },
      }
   );
};

type DocplannerUpdateSynchronizationDaysCountConfirmButtonProps = {
   readonly onSuccess: (currentDocplannerConfiguration: DocplannerHealthcareProviderConfiguration) => void;
   readonly handleSubmit: DocplannerUpdateSynchronizationDaysCountFormController['handleSubmit'];
};

export const DocplannerUpdateSynchronizationDaysCountConfirmButton = (
   props: DocplannerUpdateSynchronizationDaysCountConfirmButtonProps
): ReactElement => {
   const { executeAsync: updateSynchronizationDaysCount } = useUpdateSynchronizationDaysCountCommand({
      onSuccess: props.onSuccess,
   });
   return (
      <ModalConfirmButton
         testId={'updateClientSecret'}
         label={integrationTranslationKeys.save}
         onClick={props.handleSubmit(updateSynchronizationDaysCount)}
         blockingOperation
      />
   );
};
